import ajax from './http'

/*****公共接口******/
export function sysDic(obj) {
  return ajax({
    type: "GET",
    url: `/system/dic/read/type`,
    data: {
      ...obj
    }
  })
}
//文件上传
export function uploadFile(formData, onUploadProgress) {
  return ajax({
    url: "/upload/common",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    data: formData
  })
}
// 手机号搜索
export function organizationBaseSearchByMobile(obj) {
  return ajax({
    type: "GET",
    url: `/buz/organizationBase/search`,
    data: {
      ...obj
    }

  })
}
//获取账号信息
export function getAcconutInfo() {
  return ajax({
    url: "/system/users/getAccountInfo",
    type: "GET",
    data: {}
  })
}
//修改账号信息
export function changeAcconutInfo(data) {
  return ajax({
    url: "/system/users/modifyAccount",
    type: "POST",
    data
  })
}
// 获取机构信息
export function getOrganizationInfo(data) {
  return ajax({
    type: "POST",
    contentType: "from",
    url: `/buz/organizationBase/getInfo`,
    data
  })
}
/*******公告******/
//列表
export function chatMangeList(data) {
  return ajax({
    type: "POST",
    url: `/buz/noticeConfig/queryNewMsgList`,
    data
  })
}
// 系统所有角色
export function getRolesType() {
  return ajax({
    url: "/system/info/role",
    type: "GET",

  })
}
/*****首页******/
export function getIndexData(timeType) {
  return ajax({
    type: "GET",
    url: "/buz/policy/queryHomeStatistics",
    data: {
      timeType
    },
  })
}
// 首页客户成交统计
export function getHolderCount(timeType) {
  return ajax({
    type: "GET",
    url: "/buz/holder/getHolderCount",
  })
}
//首页获取banner
export function getBannerList() {
  return ajax({
    url: "/buz/exhibitionPicConfig/banner",
    type: "GET"
  })
}
// 首页保单保费统计
export function getAllPolicyStatistics(timeType) {
  return ajax({
    type: "GET",
    url: "/buz/policy/getAllPolicyStatistics",
  })
}
export function getAgreeAllCompany() {
  return ajax({
    url: "/buz/molInsuranceCompany/getCompanyList",
    type: "GET",
  })
}

//公告详情
export function chatMangeDetail(id) {
  return ajax({
    type: "GET",
    url: `/buz/noticeConfig/read/msg`,
    data: {
      id
    }
  })
}
//查询未读数
export function lookChatReadNum(tabCode) {
  return ajax({
    type: "GET",
    url: `/buz/noticeConfig/queryUnRead`,
    data: {
      tabCode
    }
  })
}
//保单
export function insureExportAll(data) {
  return ajax({
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/policy/policyExport`,
    data
  })
}
//订单导出
export function orderExportAll(data) {
  return ajax({
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/order/export`,
    data

  })
}
//获取电子保单
export function getProUrl(policyNo) {
  return ajax({
    url: "/buz/policy/getDownloadUrl",
    type: "GET",
    data: {
      policyNo
    }
  })
}
//订单统计
export function getOrderStatistics(data) {
  return ajax({
    url: "/buz/order/statistics",
    type: "POST",
    data
  })
}
//订单管理
export function getOrderList(data) {
  return ajax({
    url: "/buz/order/read/list",
    type: "POST",
    data
  })
}
//订单详情
export function getOrdeDetail(orderNo) {
  return ajax({
    url: "/buz/order/read/detail",
    type: "GET",
    data: {
      orderNo
    }
  })
}
//保单 统计
export function getInsureStatistics(data) {
  return ajax({
    url: "/buz/policy/statistics",
    type: "POST",
    data
  })
}
//保单 列表
export function getInsureOrderList(data) {
  return ajax({
    url: "/buz/policy/read/list",
    type: "POST",
    data
  })
}
/*******财务管理  业务员薪酬******/
export function getBaseUserSalaryList(data) {
  return ajax({
    url: "/buz/baseUserSalary/read/list",
    type: "POST",
    data
  })
}
/*****商品库******/
//导出
export function mechExportAll(data) {
  return ajax({
    type: "POST",
    forced: true,
    responseType: "blob",
    All: true,
    url: `/buz/commission/product/export`,
    data
  })
}
//一级标签
export function getFirstTag() {
  return ajax({
    url: "/buz/merchantProductTheme/array/first",
    type: "GET",
  })
}
//二级标签
export function getSecondTag(parentId) {
  return ajax({
    url: "/buz/merchantProductTheme/array/second",
    type: "GET",
    data: {
      parentId
    }
  })
}